/**
 * Dev-only console logger. Tree-shaken to zero bytes in production via the
 * `process.env.NODE_ENV` guard.
 *
 * TODO: Consider replacing with `react-utils/devLogger`, which is already used
 * elsewhere in trellis-components, carries its own production guard based on enviro,
 * and adds per-key deduplication.
 */
export function devLog(
  message: string,
  level: 'log' | 'warn' | 'error' = 'warn'
): void {
  if (process.env.NODE_ENV !== 'production') {
    console[level](message);
  }
}
